import { useState } from "react"
import {
    Grid,
    AppBar,
    Tabs,
    Tab,
} from "@material-ui/core"
import { Alert } from "@material-ui/lab"
import AccountBalanceIcon from "@material-ui/icons/AccountBalance"
import ReceiptIcon from "@material-ui/icons/Receipt"
import TarjetaExtra from "../TarjetaExtra"
import TarjetaVuelos from "../TarjetaVuelos"
import TarjetaHotel from "../TarjetaHotel"
import VPagos from "./../VPagos/VistaComrpas"
import VCompras from "../Compras/VCompras"
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart'
import EditAttributesIcon from '@material-ui/icons/EditAttributes';
import { catRoles } from "../../../constant/catRoles"
import { useSelector } from "react-redux"
import EditarDatos from "../EditarDatos"
import { usePermiso } from "../../../hooks/usePermiso"
import VGrupos from "../VGrupos"
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle'
import { esFinalizado } from "../../../utils/esFinalizado"
import VNotificaciones from "../VNotificaciones"
import NotificationsIcon from '@material-ui/icons/Notifications'
import AttachFileIcon from '@material-ui/icons/AttachFile'
import FlightIcon from '@material-ui/icons/Flight'
import VCheckIn from "../VCheckIn"
import VDocumentos from "../VDocumentos"
import VFacturas from "../VFacturas"
import VDevoluciones from "../VDevoluciones"
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile'
import AssignmentReturnIcon from '@material-ui/icons/AssignmentReturn'
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket'

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    {children}
                </div>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        "aria-controls": `scrollable-force-tabpanel-${index}`,
    };
}

export default function TapCliente() {
    const [value, setValue] = useState(0);
    const { profile } = useSelector(store => store.logeo)
    const { cliente } = useSelector(store => store.cliente)
    const [permitidoEditar] = usePermiso({ location: "FK_AdministrarClientes_Editar", initialValue: false })
    const [permitidoItems] = usePermiso({ location: "FK_AdministrarClientes_Items", initialValue: false })
    const [permitidoCheckIn] = usePermiso({ location: "FK_AdministrarClientes_CheckIn", initialValue: false })
    const [permitidoWallet] = usePermiso({ location: "FK_AdministrarClientes_Wallet", initialValue: false })
    const handleChange = (event, newValue) => {
        setValue(newValue);
    }
    return (
        <Grid item xs={12}>
            {
                esFinalizado(cliente?.paquete?.CatEstatusProceso?.IdEstatusProceso) && (
                    <Alert className="alerta" severity="info">Esta referencia esta en estatus de: {`${cliente.paquete?.CatEstatusProceso?.Descripcion}`}</Alert>
                )
            }
            <AppBar position="static" color="secondary">
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="on"
                    indicatorColor="primary"
                    aria-label="scrollable force tabs example"
                >
                    <Tab
                        label="Movimientos"
                        icon={<AccountBalanceIcon />}
                        {...a11yProps(0)}
                        value={0}
                    />
                    <Tab
                        label="Detalle"
                        icon={<ReceiptIcon />}
                        {...a11yProps(1)}
                        value={1}
                    />
                    {
                        (profile.Rol?.Id === catRoles.ADMINISTRADOR || permitidoItems) &&
                        <Tab
                            label="Items"
                            icon={<ShoppingCartIcon />}
                            {...a11yProps(2)}
                            value={2}
                        />
                    }
                    {
                        (profile.Rol?.Id === catRoles.ADMINISTRADOR || permitidoEditar) &&
                        <Tab
                            label="Verificar"
                            icon={<EditAttributesIcon />}
                            {...a11yProps(3)}
                            value={3}
                        />
                    }

                    <Tab
                        label="Grupo"
                        icon={<SupervisedUserCircleIcon />}
                        {...a11yProps(4)}
                        value={4}
                    />
                    {

                        <Tab
                            label="Notificaciones"
                            icon={<NotificationsIcon />}
                            {...a11yProps(5)}
                            value={5}
                        />
                    }
                    {
                        (profile.Rol?.Id === catRoles.ADMINISTRADOR || permitidoCheckIn) &&
                        <Tab
                            label="Check-In"
                            icon={<FlightIcon />}
                            {...a11yProps(6)}
                            value={6}
                        />
                    }
                    {
                        (profile.Rol?.Id === catRoles.ADMINISTRADOR || permitidoWallet) &&
                        <Tab
                            label="Wallet"
                            icon={<AttachFileIcon />}
                            {...a11yProps(7)}
                            value={7}
                        />
                    }
                    {
                        (profile.Rol?.Id === catRoles.ADMINISTRADOR || profile.Rol?.Id === catRoles.DEVELOPER) &&
                        <Tab
                            label="Extras contratados"
                            icon={<ShoppingBasketIcon />}
                            {...a11yProps(8)}
                            value={8}
                        />
                    }
                    {
                        (profile.Rol?.Id === catRoles.ADMINISTRADOR || profile.Rol?.Id === catRoles.DEVELOPER) &&
                        <Tab
                            label="Devoluciones"
                            icon={<AssignmentReturnIcon />}
                            {...a11yProps(9)}
                            value={9}
                        />
                    }
                    {
                        (profile.Rol?.Id === catRoles.ADMINISTRADOR || profile.Rol?.Id === catRoles.DEVELOPER) &&
                        <Tab
                            label="Facturas"
                            icon={<InsertDriveFileIcon />}
                            {...a11yProps(10)}
                            value={10}
                        />
                    }
                </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
                <VPagos />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <TarjetaExtra />
                <TarjetaVuelos />
                <TarjetaHotel />
            </TabPanel>
            {
                (profile.Rol?.Id === catRoles.ADMINISTRADOR || permitidoItems) &&
                <TabPanel value={value} index={2}>
                    <VCompras />
                </TabPanel>
            }
            {
                (profile.Rol?.Id === catRoles.ADMINISTRADOR || permitidoEditar) &&
                <TabPanel value={value} index={3}>
                    <EditarDatos />
                </TabPanel>
            }
            <TabPanel value={value} index={4}>
                <VGrupos />
            </TabPanel>
            <TabPanel value={value} index={5}>
                <VNotificaciones />
            </TabPanel>

            {
                (profile.Rol?.Id === catRoles.ADMINISTRADOR || permitidoCheckIn) &&
                <TabPanel value={value} index={6}>
                    <VCheckIn />
                </TabPanel>
            }
            {
                (profile.Rol?.Id === catRoles.ADMINISTRADOR || permitidoWallet) &&
                <TabPanel value={value} index={7}>
                    <VDocumentos />
                </TabPanel>
            }
            {
                (profile.Rol?.Id === catRoles.ADMINISTRADOR || profile.Rol?.Id === catRoles.DEVELOPER) &&
                <TabPanel value={value} index={8}>
                </TabPanel>
            }
            {
                (profile.Rol?.Id === catRoles.ADMINISTRADOR || profile.Rol?.Id === catRoles.DEVELOPER) &&
                <TabPanel value={value} index={9}>
                    <VDevoluciones />
                </TabPanel>
            }
            {
                (profile.Rol?.Id === catRoles.ADMINISTRADOR || profile.Rol?.Id === catRoles.DEVELOPER) &&
                <TabPanel value={value} index={10}>
                    <VFacturas />
                </TabPanel>
            }
        </Grid>
    );
}
